import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HostService } from 'services/host/host.service'


@Injectable({
	providedIn: 'root'
})
export class ThirdService {

	constructor(public http: HttpClient, public hostService: HostService) { }

	host = this.hostService.host;

	create_andcheck_third = 'thirds'
	update_third = 'third/'
	get_third_acc = 'third/by/account/'


	createThird(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('access')}`
				})
			};
			this.http.post(`${this.host}${this.create_andcheck_third}`, data, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

	updateThird(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('access')}`
				})
			};
			this.http.put(`${this.host}${this.update_third}${data.id}`, data, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

	getThird(): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('access')}`
				})
			};
			this.http.get(`${this.host}${this.create_andcheck_third}`, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		});
	}

	getThirdByacc(nit): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('access')}`
				})
			};
			this.http.get(`${this.host}${this.get_third_acc}${nit}`, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		});
	}

	// filterSales(args: any): Promise<any>{
	//   return new Promise((resolve, reject) => {
	//     this.http.post(`${this.host}${this.filterSale}`, args)
	//       .subscribe(
	//         data => {
	//           resolve(data);
	//         },
	//         error => {
	//           reject(error);
	//         }
	//       )
	//   })
	// }
}
